import { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';

const AdditionalInformationField = ({ value, fieldName, onChange, required, isSubmitting}) => {
  const FIELD_MAX_LENGTH = 250

  const [touched, setTouched] = useState(false);
  const fieldNameDisplay = fieldName ? fieldName : 'Additional Information';
  
  const getAdditionalInformationError = () => {
    if (required && !value) return `${fieldNameDisplay} is required.`;
    if (value.length > FIELD_MAX_LENGTH) return `${fieldNameDisplay} must be fewer than ${FIELD_MAX_LENGTH} characters.`;
    return null;
  };

  const errorMessage = getAdditionalInformationError();

  return (
  <Form.Group>
    <InputGroup>
      <Form.FloatingLabel label={<span className={required ? 'required-field': ''}>{fieldNameDisplay}</span>} controlId="additional-information">
        <Form.Control
          as="textarea"
          rows={3}
          maxLength={FIELD_MAX_LENGTH}
          value={value}
          disabled={isSubmitting}
          required={required}
          isInvalid={!!errorMessage && touched}
          onChange={(e) => {
            setTouched(true);
            onChange(e.target.value);
          }}
          onBlur={() => setTouched(true)}
          style={{ height: '100px' }}
          placeholder=""
        />
      </Form.FloatingLabel>
      <Form.Control.Feedback type="invalid">
        {errorMessage}
      </Form.Control.Feedback>
    </InputGroup>
    <Form.Text muted className="float-end">{value.length}/{FIELD_MAX_LENGTH}</Form.Text>
  </Form.Group>
)};

export default AdditionalInformationField;